/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ProxyService } from './services/proxy.service';
import { TestTimerService } from './services/test-timer.service';
import { GetUserHistoryService } from './services/get-user-history.service';
import { AddHistoryService } from './services/add-history.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ProxyService,
    TestTimerService,
    GetUserHistoryService,
    AddHistoryService,
    ApiConfiguration
  ],
})
export class AiProxyApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<AiProxyApiModule> {
    return {
      ngModule: AiProxyApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: AiProxyApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('AiProxyApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
